import { render, staticRenderFns } from "./AgentPage.vue?vue&type=template&id=2f56c1e6&scoped=true&lang=pug&"
import script from "./AgentPage.vue?vue&type=script&lang=js&"
export * from "./AgentPage.vue?vue&type=script&lang=js&"
import style0 from "./AgentPage.vue?vue&type=style&index=0&id=2f56c1e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f56c1e6",
  null
  
)

export default component.exports